<template>
  <div class="manage-content">
    <div class="location" v-if="this.$store.state.user_type === 0">企业管理中心 / 我的推广 / 推广详情</div>
    <div class="location" v-if="this.$store.state.user_type === 1">达人管理中心 / 代客下单 / 推广详情</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <extension-status :is_success="is_success" :is_examine="is_examine"></extension-status>
      <extension-info :task_title="task_title"
                      :task_price="task_price"
                      :task_clicks="task_clicks"
                      :create_time="create_time"
                      :task_sn="task_sn"
                      :receipt_time="receipt_time"
                      :task_time="task_time"
                      :task_url="task_url"
                      :reward_type="reward_type">
      </extension-info>
      <extension-completion :statistics="statistics"></extension-completion>
      <extension-receipt :list="list"
                         :split_num="split_num"
                         :count="count">
      </extension-receipt>
      <div class="repeat flex justify-content margin-top-20 margin-bottom-20">
        <el-button style="width:20%;" @click="goBack">返回列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {epOrderDetail} from '@/config/api.js'
import ExtensionInfo from './components/ExtensionInfo'
import ExtensionStatus from './components/ExtensionStatus'
import ExtensionCompletion from './components/ExtensionCompletion'
import ExtensionReceipt from './components/ExtensionReceipt'
export default {
  name: 'ExtensionDetail',
  props: {
    detailId:String
  },
  components: {
    ExtensionStatus,
    ExtensionInfo,
    ExtensionCompletion,
    ExtensionReceipt
  },
  data(){
    return {
      count: '',
      task_title: '',
      task_price: '',
      task_clicks: '',
      task_sn: '',
      split_num: '',
      create_time: '',
      receipt_time: '',
      task_time: '',
      task_url: '',
      statistics: {
        task_clicks: '',
        real_click: '',
        completion_rate: '',
        task_price: '',
        settlement_free: '',
        balance_free: ''
      },
      is_success: null,
      is_examine: null,
      list: [],
      template_data: null,
      reward_type:''
    }
  },
  methods: {
    getOrder() {
      let data = {
        task_id: this.detailId,
        user_id: this.$store.state.user_id
      };
      this.$post(epOrderDetail, data)
              .then(res => {
                const data = res.data;
                this.task_title = data.task_title;
                this.count = data.count;
                this.task_id = data.task_id;
                this.task_price = data.task_price;
                this.task_clicks = data.task_clicks;
                this.task_sn = data.task_sn;
                this.task_url = data.task_url;
                this.create_time = data.create_time;
                this.receipt_time = data.receipt_time;
                this.task_time = data.task_time;
                this.split_num = data.split_num;
                this.is_success = Number(data.is_success);
                this.statistics.task_clicks = data.statistics.task_clicks;
                this.statistics.real_click = data.statistics.real_click;
                this.statistics.completion_rate = data.statistics.completion_rate;
                this.statistics.task_price = data.statistics.task_price;
                this.statistics.settlement_free = data.statistics.settlement_free;
                this.statistics.balance_free = data.statistics.balance_free;
                this.is_success = Number(data.is_success);
                this.is_examine = Number(data.is_examine);
                this.list.name = data.list.name;
                this.list.head_img = data.list.head_img;
                this.list.task_click = data.list.task_click;
                this.list.click_num = data.list.click_num;
                this.list = data.list;
                this.template_data = JSON.parse(data.template_data);
                this.$store.state.receipt_time = data.receipt_time;
                this.reward_type = data.reward_type
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    goBack () {
      if (this.$store.state.user_type === 0) {
        this.$router.push('/enterprise/order')
      } else if (this.$store.state.user_type === 1) {
        this.$router.push('/daren/agent')
      }
    }
  },
  created() {
    this.getOrder();
  }
}
</script>
<style scoped>
    .margin-top-20{margin-top:30px;}
</style>
